import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineJourneys,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';

const journeys = combineJourneys([{
  acceptance: AcceptanceRepository.ACCEPTED
}]).items;
const journey = journeys[0];
const journeyElementIds = journey.journeyElements.map((je: JourneyElementCommon) => je.id);
const missingTsa = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.DEFAULT
}], {
  journeyElementIds
}).items;
const withTsa = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;
export const tsa: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(missingTsa, 201),
    createMockDataWithResponse(withTsa, 201)
  ],
  getRegulatoryDetails: [createMockData({
    ...RegulatoryDetailsReplyDataRepository.MISSING_TSA,
    travelerId: 'JOURNEY-TRAVELER-0-MOCK'
  })],
  addRegulatoryDetails: [createMockData({
    ...RegulatoryDetailsReplyDataRepository.STORED_TSA,
    travelerId: 'JOURNEY-TRAVELER-0-MOCK'
  })],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveJourney: [createMockData(journey)]
};
